import { useState, useEffect, useRef } from 'react';
import classes from "./Funktioniert.module.css";
import image1 from "../public/HomePage/so-funktioniert-stu/SoFunktioniertStu.webp";
import image2 from "../public/HomePage/so-funktioniert-stu/SoFunktioniertStu3.webp";
import image3 from "../public/HomePage/so-funktioniert-stu/SoFunktioniertStu2.webp";

import tabletImage1 from "../public/HomePage/so-funktioniert-stu/tablet/SoFunktioniertStu.webp";
import tabletImage2 from "../public/HomePage/so-funktioniert-stu/tablet/SoFunktioniertStu3.webp";
import tabletImage3 from "../public/HomePage/so-funktioniert-stu/tablet/SoFunktioniertStu2.webp";

const desktopImages = [
    { image: image1, alt: 'Image Profil' },
    { image: image2, alt: 'Website Function' },
    { image: image3, alt: 'Image Payment' },
];

const tabletImages = [
    { image: tabletImage1, alt: 'Tablet Image 1' },
    { image: tabletImage2, alt: 'Tablet Image 2' },
    { image: tabletImage3, alt: 'Tablet Image 3' },
];

const Funktioniert = ({ onJoinDiscountClick }) => {
    const [images, setImages] = useState(desktopImages);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [currentBoxIndex, setCurrentBoxIndex] = useState(0);
    const boxesRef = useRef([]);
    const [overlayTop, setOverlayTop] = useState(0);
    const [boxHeight, setBoxHeight] = useState(0);

    const updateImages = () => {
        if (window.innerWidth <= 1200) {
            setImages(tabletImages);
        } else {
            setImages(desktopImages);
        }
    };

    useEffect(() => {
        updateImages();
        window.addEventListener('resize', updateImages);
        return () => window.removeEventListener('resize', updateImages);
    }, []);

    useEffect(() => {
        if (window.innerWidth <= 900) {
            return;
        }

        const intervalDuration = currentImageIndex === images.length - 1 ? 5000 : 3000;

        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                prevIndex < images.length - 1 ? prevIndex + 1 : 0
            );
            setCurrentBoxIndex((prevIndex) =>
                prevIndex < 2 ? prevIndex + 1 : 0
            );
        }, intervalDuration);

        return () => clearInterval(interval);
    }, [currentImageIndex, images.length]);

    useEffect(() => {
        if (window.innerWidth <= 900) {
            return;
        }

        if (boxesRef.current[currentBoxIndex]) {
            const box = boxesRef.current[currentBoxIndex];
            const { height } = box.getBoundingClientRect();
            const offsetTop = box.offsetTop;
            setOverlayTop(offsetTop);
            setBoxHeight(height);
        }
    }, [currentBoxIndex]);

    const handleBoxHover = (index) => {
        setCurrentBoxIndex(index);
        setCurrentImageIndex(index);
    };

    return (
        <div id="produkt" className={classes.outsideContainer}>
            <div className={classes.container}>
                <div className={classes.slideshow}>
                    {images.map((image, index) => (
                        <img
                            loading="lazy"
                            key={index}
                            src={image?.image}
                            className={`${classes.slideshow} ${index === currentImageIndex ? classes.active : ''}`}
                            alt={image?.alt}
                        />
                    ))}
                </div>
                <div className={classes.stuWorkInfos}>
                    <h3>So funktioniert Stu.</h3>
                    <div className={classes.boxesContainer}>
                        <div
                            className={classes.overlay}
                            style={{ top: `${overlayTop}px`, height: `${boxHeight}px` }}
                        />
                        <div
                            className={classes.box}
                            ref={el => boxesRef.current[0] = el}
                            onMouseEnter={() => handleBoxHover(0)}
                        >
                            <div className={classes.boxInfos}>
                                <div className={classes.boxIcon}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <path d="M26.1336 20.6028C26.2554 21.1754 26.3163 21.7662 26.3163 22.3754C26.3163 27.0659 22.5152 30.867 17.8248 30.867C13.1343 30.867 9.33316 27.0659 9.33316 22.3754C9.33316 17.6849 13.1343 13.8838 17.8248 13.8838C18.3547 13.8838 18.8725 13.9325 19.372 14.0239M33.9417 18.2459C34.2828 19.5678 34.4594 20.9506 34.4594 22.376C34.4594 31.562 27.0095 39.0119 17.8235 39.0119C8.63744 39.0119 1.1875 31.562 1.1875 22.376C1.1875 13.1899 8.63744 5.74 17.8235 5.74C18.993 5.74 20.1322 5.86183 21.2286 6.09331M25.8832 14.505L17.5865 22.8017M25.8845 14.5053V8.57219L31.8725 2.57812L33.4258 6.96403L37.8117 8.51723L31.8176 14.5052L25.8845 14.5053Z" stroke="#101010" strokeWidth="1.82746" strokeMiterlimit="10"/>
                                    </svg>
                                </div>
                                <h4 className={classes.hiddenTitle}>Finde Studios und Locations.</h4>
                                <h4 className={classes.hiddenPhoneTitle}>Finde Studios und Locations.</h4>
                                <span>
                                    Finde den perfekten Ort für Musik, Foto und Video - nutze unsere Plattform mit Filtern und Kategorien.
                                </span>
                            </div>
                        </div>
                        <div className={classes.separatorLine}></div>
                        <div
                            className={classes.box}
                            ref={el => boxesRef.current[1] = el}
                            onMouseEnter={() => handleBoxHover(1)}
                        >
                            <div className={classes.boxInfos}>
                                <div className={classes.boxIcon}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="35" viewBox="0 0 39 35" fill="none">
                                        <path d="M26.1601 15.5957C27.3968 14.0615 28.1377 12.1072 28.1377 9.97794C28.1377 5.02523 24.1242 1.01172 19.1714 1.01172C14.2187 1.01172 10.2052 5.02523 10.2052 9.97794C10.2052 12.1072 10.9461 14.0615 12.1828 15.5957M5.86602 22.4113C3.38674 24.9547 1.66 28.5191 1.625 33.3551H37.3732C37.3382 28.5249 35.6115 24.9664 33.1322 22.423M32.8506 29.5092L32.7806 31.2943C32.7806 32.4377 31.8472 33.3594 30.7097 33.3594H8.27368C7.1303 33.3594 6.20276 32.4319 6.20276 31.2943L6.13276 29.5092L6.06859 27.94L5.6719 17.6554C5.6719 16.5178 6.60528 15.5961 7.74283 15.5961H31.2347C32.3781 15.5961 33.3056 16.5237 33.3056 17.6554L32.9089 27.94L32.8447 29.5092H32.8506ZM21.751 24.1775C21.751 25.4212 20.7429 26.4293 19.4993 26.4293C18.2557 26.4293 17.2475 25.4212 17.2475 24.1775C17.2475 22.9339 18.2557 21.9258 19.4993 21.9258C20.7429 21.9258 21.751 22.9339 21.751 24.1775Z" stroke="#101010" strokeWidth="1.6165" strokeMiterlimit="10"/>
                                    </svg>
                                </div>
                                <h4 className={classes.hiddenTitle}>Engagiere Kreative.</h4>
                                <span>
                                    Entdecke talentierte Kreative und wähle den perfekten Partner für deine Vision aus.
                                </span>
                            </div>
                        </div>
                        <div className={classes.separatorLine}></div>
                        <div
                            className={classes.box}
                            ref={el => boxesRef.current[2] = el}
                            onMouseEnter={() => handleBoxHover(2)}
                        >
                            <div className={classes.boxInfos}>
                                <div className={classes.boxIcon}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="34" viewBox="0 0 37 34" fill="none">
                                        <path d="M25.6181 13.4526L15.9675 23.3136L15.4648 23.8163L14.968 23.3136L11.3906 19.7363L11.8875 19.2336L15.4648 22.8168L25.1154 12.95L25.6181 13.4526Z" fill="#101010"/>
                                        <path d="M15.4648 24.5003L10.7068 19.7364L11.8875 18.5498L15.4648 22.1271L25.1154 12.2661L26.2961 13.4469L15.4648 24.5003Z" fill="#101010"/>
                                        <path d="M33.4684 33.5428H3.53468C2.0909 33.5428 0.910156 32.3679 0.910156 30.9183V5.08213C0.910156 3.6325 2.0909 2.4576 3.53468 2.4576H33.4684C34.9121 2.4576 36.0929 3.63835 36.0929 5.08213V30.9183C36.0929 32.3679 34.9121 33.5428 33.4684 33.5428ZM3.53468 4.39239C3.15474 4.39239 2.84494 4.70219 2.84494 5.08213V30.9183C2.84494 31.2982 3.15474 31.608 3.53468 31.608H33.4684C33.8483 31.608 34.1581 31.2982 34.1581 30.9183V5.08213C34.1581 4.70219 33.8483 4.39239 33.4684 4.39239H3.53468Z" fill="#101010"/>
                                        <path d="M19.469 0.359375H17.5342V6.29233H19.469V0.359375Z" fill="#101010"/>
                                        <path d="M27.7223 0.359375H25.7875V6.29233H27.7223V0.359375Z" fill="#101010"/>
                                        <path d="M11.2387 0.359375H9.30387V6.29233H11.2387V0.359375Z" fill="#101010"/>
                                    </svg>
                                </div>
                                <h4 className={classes.hiddenTitle}>Buche ganz einfach.</h4>
                                <h4 className={classes.hiddenPhoneTitle}>Buche ganz einfach.</h4>
                                <span>
                                    Mit wenigen Klicks reservierst du dein Studio undbuchst Kreative, alles sicher und schnell bezahlt.
                                </span>
                            </div>
                        </div>
                        <div className={classes.allStudiosButtonContainer}>
                            <button
                              type="button"
                              className={`${classes.allStudiosButton} regularLarge`}
                              onClick={onJoinDiscountClick}
                            >
                                Beitreten & Rabatt sichern
                            </button>
                        </div>
                        <div className={classes.allStudiosButtonContainerPhone}>
                            <button
                              type="button"
                              className={`${classes.allStudiosButton} regularMiddle`}
                              onClick={onJoinDiscountClick}
                            >
                                Beitreten & Rabatt sichern
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.longLineContainer}>
                <div className={classes.longLine}></div>
            </div>
        </div>
    );
};

export default Funktioniert;